import { affiliateApi } from '../lib/axios';
import type {
  BrandStats,
  RevenueTrend,
  RevenueBreakdown,
  EarningsSummary,
  RecentWins,
  UpdateMonthlyGoalRequest,
  UpdateMonthlyGoalResponse,
  PayoutHistoryResponse,
  TopBrandsResponse,
} from '../types/affiliate-dashboard';

export const affiliateDashboardApi = {
  // Brand Statistics
  getBrandStats: async (): Promise<BrandStats> => {
    const response = await affiliateApi.get<BrandStats>('/analytics/affiliate/brand-stats');
    return response.data;
  },

  // Revenue Trend
  getRevenueTrend: async (params: { days?: number; startDay?: string; endDay?: string }): Promise<RevenueTrend> => {
    const response = await affiliateApi.get<RevenueTrend>('/analytics/affiliate/revenue-trend', { params });
    return response.data;
  },

  // Revenue Breakdown
  getRevenueBreakdown: async (): Promise<RevenueBreakdown> => {
    const response = await affiliateApi.get<RevenueBreakdown>('/analytics/affiliate/revenue-breakdown');
    return response.data;
  },

  // Earnings Summary
  getEarningsSummary: async (): Promise<EarningsSummary> => {
    const response = await affiliateApi.get<EarningsSummary>('/analytics/affiliate/earnings-summary');
    return response.data;
  },

  // Recent wins: latest sales + personal bests
  getRecentWins: async (programId?: string): Promise<RecentWins> => {
    const response = await affiliateApi.get<RecentWins>('/analytics/affiliate/recent-wins', {
      params: programId ? { programId } : undefined,
    });
    return response.data;
  },

  // Update Monthly Goal
  updateMonthlyGoal: async (data: UpdateMonthlyGoalRequest): Promise<UpdateMonthlyGoalResponse> => {
    const response = await affiliateApi.patch<UpdateMonthlyGoalResponse>('/affiliates/monthly-goal', data);
    return response.data;
  },

  // Payout History (existing endpoint)
  getPayoutHistory: async (params: { page?: number; limit?: number; programId?: string } = {}): Promise<PayoutHistoryResponse> => {
    const response = await affiliateApi.get<PayoutHistoryResponse>('/payout/affiliate/history', { params });
    return response.data;
  },

  // Top Brands for Marquee
  getTopBrands: async (limit: number = 20): Promise<TopBrandsResponse> => {
    const response = await affiliateApi.get<TopBrandsResponse>('/analytics/affiliate/top-brands', { params: { limit } });
    return response.data;
  },
};
